import { type ReactNode, useSyncExternalStore } from 'react'
import { ChevronDown } from 'lucide-react'

const phoneQuery = '(max-width: 620px)'
function subscribe(onChange: () => void) {
  const media = window.matchMedia(phoneQuery)
  media.addEventListener('change', onChange)
  return () => media.removeEventListener('change', onChange)
}
export function usePhoneLayout() {
  return useSyncExternalStore(subscribe, () => window.matchMedia(phoneQuery).matches, () => false)
}

export function MobileDetails({ summary, children, className = '' }: { summary: ReactNode; children: ReactNode; className?: string }) {
  const phone = usePhoneLayout()
  if (!phone) return <>{children}</>
  return <details className={`mobile-details ${className}`}>
    <summary><span>{summary}</span><ChevronDown size={20} aria-hidden="true" /></summary>
    <div className="mobile-details-content">{children}</div>
  </details>
}
